(() => {
  /** Include only a valid star1–star5 value from the review-email link. */
  const updateRating = () => {
    const params = new URLSearchParams(window.location.search);
    const match = (params.get('utm_content') || '').match(/^star([1-5])$/);

    for (const root of document.querySelectorAll('[data-pluxy-feedback]')) {
      const input = root.querySelector('[data-feedback-rating]');
      const note = root.querySelector('[data-feedback-rating-note]');
      if (!input || !note) continue;

      if (match) input.value = `${match[1]}/5`;
      const saved = input.value.match(/^([1-5])\/5$/);
      if (!saved) continue;

      note.textContent = note.dataset.ratingLabel.replace('__RATING__', saved[1]);
      note.hidden = false;
    }
  };

  updateRating();
  document.addEventListener('shopify:section:load', updateRating);
})();
